export const routes = {
  SIGNIN: '/sign-in',
  TECHNICAL_SIGNIN: '/technical-sign-in',
  PORTAL_AUTHORIZATION: '/portal-authorization',
  VERIFY_ONEFIIT: '/verify-onefiit',
  FORGOT_PASSWORD: '/forgot-password',
  SET_PASSWORD: '/set-password',
  PROFILE: '/profile',
  FAQ: '/faq',
  TERMS_CONDITIONS: '/terms-conditions',
  WEEKLY_WORKOUTS: '/workouts',
  WORKOUTS: '/browse',
  WORKOUT: '/workouts/:id',
  WORKOUT_PDF: '/workouts/:id/pdf',
  ONBOARDING_GYM_TYPE: '/onboarding/gym-type',
  ONBOARDING_GYM_EQUIPMENT: '/onboarding/gym-equipment',
  HOME: '/',
  RESOURCES: '/resources',
  RESOURCE: '/resources/:id',
  RESOURCE_LISTS_HOME: '/resource-lists-home',
  RESOURCE_LIST: '/resource-lists/:id',
  AUTH_LISTENER: '/auth-listener',
  LIBRARY: '/library',
  COLLECTION: '/library/collections/:id',
  COLLECTIONS: '/library/collections',
  CHALLENGES: '/library/challenges',
  CHALLENGE: '/library/challenges/:id',
  TRAINING_PLANS: '/library/training-plans',
  TRAINING_PLANS_ACTIVE: '/library/training-plans/active',
  TRAINING_PLAN: '/library/training-plans/:id',
  TRAINING_PLAN_ACTIVE_INSTANCE: '/library/training-plans/active/:id',
};
